export class GuestService {
  constructor() {
    this.guests = []
    this.loadGuests()
  }

  async loadGuests() {
    try {
      // Use the actual FVV API endpoint
      const response = await fetch('https://www.fvv-net.de/api/qrcheckin/all')
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }
      const data = await response.json()
      this.guests = data || []
    } catch (error) {
      console.error('Error loading guests:', error)
      // Fallback to local demo data for development
      try {
        const fallbackResponse = await fetch('/demo_all.json')
        const fallbackData = await fallbackResponse.json()
        this.guests = fallbackData.guests || []
      } catch (fallbackError) {
        console.error('Error loading fallback data:', fallbackError)
        this.guests = []
      }
    }
  }

  getGuests() {
    return this.guests
  }

  findGuestById(id) {
    return this.guests.find(guest => guest.id === id)
  }

  findGuestByEmail(email) {
    return this.guests.find(guest => guest.email === email)
  }

  async checkInGuest(guest) {
    try {
      // Send only the uniqueId to the API
      const response = await fetch('https://www.fvv-net.de/api/qrcheckin/confirm', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ uniqueId: guest.uniqueId })
      })

      const result = await response.json()
      
      if (result.success) {
        // Update local data with the response
        await this.loadGuests()
        return { success: true, message: result.message, guest: result.guest }
      } else {
        return { success: false, message: result.message, guest: null }
      }
    } catch (error) {
      console.error('Check-in failed:', error)
      return { success: false, message: 'Fehler beim Check-in', guest: null }
    }
  }

  async resetGuest(guest) {
    try {
      const response = await fetch('https://www.fvv-net.de/api/qrcheckin/reset', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ uniqueId: guest.uniqueId })
      })

      const result = await response.json()

      if (result.success) {
        await this.loadGuests()
        return { success: true, message: result.message, guest: result.guest }
      } else {
        return { success: false, message: result.message, guest: null }
      }
    } catch (error) {
      console.error('Reset failed:', error)
      return { success: false, message: 'Fehler beim Zurücksetzen', guest: null }
    }
  }

  async deleteGuest(guest) {
    try {
      const response = await fetch('https://www.fvv-net.de/api/qrcheckin/delete', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ uniqueId: guest.uniqueId })
      })

      const result = await response.json()

      if (result.success) {
        await this.loadGuests()
        return { success: true, message: result.message, guest: result.guest }
      } else {
        return { success: false, message: result.message, guest: null }
      }
    } catch (error) {
      console.error('Delete failed:', error)
      return { success: false, message: 'Fehler beim Löschen', guest: null }
    }
  }

  async processQRCode(qrData) {
    try {
      // Handle plain text uniqueId from QR code
      const uniqueId = qrData.trim()
      
      // Find guest by uniqueId
      const guest = this.guests.find(g => g.uniqueId === uniqueId)
      
      if (guest) {
        if (guest.checkedIn) {
          return { success: false, message: 'Gast bereits eingecheckt', guest }
        } else {
          // Use the check-in API with the uniqueId
          const result = await this.checkInGuest(guest)
          return result
        }
      } else {
        return { success: false, message: 'Gast nicht gefunden', guest: null }
      }
    } catch (error) {
      console.error('QR processing error:', error)
      return { success: false, message: 'Fehler bei der QR-Code Verarbeitung', guest: null }
    }
  }
}
